import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState as driverState } from "./DriverState";
import { IState } from "slices";
import { DriverItem } from "app/data/drivers/models";

export const driversSlice = createSlice({
    name: "driver",
    initialState: driverState,
    reducers: {
        setDriver: (state, action: PayloadAction<{ driver: DriverItem }>) => {
            state.selectedDriverId = action.payload.driver.driverId;
            state.selectedDriver = action.payload.driver;
        }
    },
});

export const {
    setDriver
} = driversSlice.actions;

export const driversSelector = (state: IState) => state.driver;

const driverReducer = driversSlice.reducer;
export default driverReducer;
